const DetalleMedico = () => import('@/app/views/medicos/views/DetalleMedico');
const ListadoMedicos = () => import('@/app/views/medicos/views/ListadoMedicos');

const medicosRoutes = [
  {
    path: 'medicos',
    redirect: '/gestion/medicos',
    name: 'Médicos',
    component: {
      render(c) {
        return c('router-view');
      }
    },
    children: [
      {
        path: '',
        name: 'Listado',
        component: ListadoMedicos,
        meta: {
          auth: true,
        }
      },
      {
        path: '/medicos',
        name: '',
        component: DetalleMedico,
        meta: {
          auth: true,
        },
        children: [
          {
            path: '/gestion/medicos/:id',
            name: 'Detalle',
            meta: {
              auth: true,
            }
          }
        ]
      },

    ]
  }
];

export default medicosRoutes;
